import React, { Component } from 'react'
import { Col } from 'react-bootstrap'
import { LayoutAuth } from 'Components/Layout/Auth'
import { BackgroundLogo } from 'Components/Sidebar/BackgroundLogo'
import injectStyles from 'react-jss'

const styles = {
  container: {
    /*padding: 20,
    maxWidth: 600,
    margin: '0 auto',
    boxSizing: 'border-box',
    textAlign: 'center',*/
    position: 'relative',
    width: '100%',
    height: '100%',
    '&: h1': {
      fontSize: 28,
      margin: '0 0 40px 0',
    },
  },
  inner: {
    position: 'absolute',
    width: '100%',
    maxWidth: 360,
    left: 0,
    right: 0,
    top: '50%',
    margin: 'auto',
    transform: 'translateY(-50%)',
  },
  logo: {
    marginBottom: '75px',
  },
}

class ResetPasswordSuccess extends Component {
  render() {
    const { classes } = this.props
    return (
      <LayoutAuth>
        <Col xs={12} md={6} className={classes.logo}>
          <BackgroundLogo />
        </Col>
        <Col xs={12} md={6}>
          <div className={classes.container}>
            <div className={classes.inner}>
              <h1>Reset Successful</h1>
              <br />
              <p>
                Your password was reset successfully. You can now return to the
                app to login.
              </p>
            </div>
          </div>
        </Col>
      </LayoutAuth>
    )
  }
}

export default injectStyles(styles)(ResetPasswordSuccess)



// WEBPACK FOOTER //
// ./src/Components/Auth/ResetPasswordSuccess/index.js